module.exports = __webpack_public_path__ + "img/money.793e099b.svg";